"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSelectors = exports.TableAccessors = void 0;
/* eslint-disable arrow-body-style */
/* eslint-disable max-classes-per-file */
var reselect_1 = require("reselect");
var types_1 = require("@dtna/dvs-core-dcp-client-constants/lib/constants/types");
var table_model_1 = require("../models/table.model");
var TableAccessors = /** @class */ (function () {
    function TableAccessors() {
    }
    TableAccessors.getTableState = function (state) { return state.table; };
    return TableAccessors;
}());
exports.TableAccessors = TableAccessors;
var TableSelectors = /** @class */ (function () {
    function TableSelectors() {
    }
    TableSelectors.selectCurrentSort = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) { return (table[tableId] != null && table[tableId].currentSort != null
        ? table[tableId].currentSort
        : {
            currentSortOrder: types_1.SORT_ORDER.ASCENDING,
            currentSortColumn: undefined,
        }); }); };
    TableSelectors.selectFilters = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) { return (table[tableId] != null
        ? table[tableId].filters
        : {}); }); };
    TableSelectors.selectFilteredData = function (tableId, data) { return (0, reselect_1.createSelector)([TableSelectors.selectFilters(tableId)], function (filters) {
        var filtersKeys = Object.keys(filters);
        return data.filter(function (item) { return filtersKeys.every(function (key) { var _a; return ((_a = item[key]) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(filters[key].toLowerCase())) >= 0; }); });
    }); };
    TableSelectors.selectSelectedRows = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) {
        return table[tableId] != null ? table[tableId].selectedRows : [];
    }); };
    TableSelectors.selectCurrentPage = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) { return (table[tableId] != null
        ? table[tableId].currentPage
        : 0); }); };
    TableSelectors.selectPageIsLoading = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) { return table[tableId] != null
        && table[tableId].pageIsLoading; }); };
    TableSelectors.selectItemsPerPage = function (tableId) { return (0, reselect_1.createSelector)([TableAccessors.getTableState], function (table) { return (table[tableId] != null && !!table[tableId].itemsPerPage
        ? table[tableId].itemsPerPage
        : table_model_1.DEFAULT_ITEMS_PER_PAGE); }); };
    return TableSelectors;
}());
exports.TableSelectors = TableSelectors;
